import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext"; // Adjust path as needed

const Navbar = (): React.JSX.Element => {
  const { currentUser, logout } = useAuth(); // Destructure currentUser and logout from useAuth()
  const navigate = useNavigate();
  const [error, setError] = React.useState<string>("");

  const handleLogout = async (): Promise<void> => {
    setError(""); // Clear any previous error
    try {
      await logout(); // Call the logout function from your AuthContext
      navigate("/login"); // Redirect to the login page after successful logout
    } catch (err: any) {
      // You can add more specific Firebase error handling here if needed
      setError("Failed to log out: " + (err.message || "Unknown error"));
      console.error("Logout error:", err);
    }
  };

  return (
    <section>
      <h3 style={{ textAlign: "center" }}>Edit artworkbyjocelyn.com:</h3>
      <nav
        className="media"
        style={{
          alignItems: "center",
          display: "flex",
          justifyContent: "space-between",
          padding: "10px",
          borderBottom: "1px solid #ccc",
        }}
      >
        <div className="media">
          <Link to="/" style={{ marginRight: "15px" }}>
            Home
          </Link>
          <span>
            <a
              href="https://console.firebase.google.com/u/0/project/artworkbyjocelyn/overview"
              target="_blank"
              rel="noopener noreferrer"
              style={{ display: "flex", marginRight: "15px" }}
            >
              Firebase Project &#x1F517;
            </a>
            <a
              href="https://artworkbyjocelyn.com"
              target="_blank"
              rel="noopener noreferrer"
              style={{ display: "flex", marginRight: "15px" }}
            >
              artworkbyjocelyn.com &#x1F517;
            </a>
          </span>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {currentUser ? (
            <>
              <span style={{ marginRight: "15px" }}>
                Hello {currentUser.email}
              </span>
              <button className="btn" onClick={handleLogout}>
                Sign Out
              </button>
            </>
          ) : (
            <>
              <Link to="/login" style={{ marginRight: "15px" }}>
                Log In
              </Link>
            </>
          )}
        </div>
        {error && (
          <p
            style={{
              color: "red",
              position: "absolute",
              top: "10px",
              right: "10px",
            }}
          >
            {error}
          </p>
        )}
      </nav>
    </section>
  );
};

export default Navbar;
